import { render, staticRenderFns } from "./attendanceTodayComponent.vue?vue&type=template&id=6142f9f3&"
import script from "./attendanceTodayComponent.vue?vue&type=script&lang=js&"
export * from "./attendanceTodayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports